import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { SelectOptionService } from 'src/app/shared-data/select-option.service';
import { ValidationService } from 'src/app/services/validation/validation.service';
import * as moment from 'moment';
import { DEFAULT_CROSS_DOMAIN_CSS_CLASS, GiphyService, TrxService } from '~services';
import { ZipYiElement } from '~services/biocatch/zip-yi-element.enum';

@Component({
  selector: 'app-buy-for-friend-v2',
  templateUrl: './buy-for-friend.component.html',
  styleUrls: ['./buy-for-friend.component.scss'],
})
export class BuyForFriendV2Component {
  @Output()
  public readonly checkoutForFriend = new EventEmitter<void>();

  @Input() public isCardAvailability: any;
  @Input() public isGifEnabled: boolean;

  @ViewChild('inputFriendEmail', { static: true }) inputFriendEmailRef: ElementRef;
  @ViewChild('inputFriendEmailConfirm', { static: true }) inputFriendEmailConfirmRef: ElementRef;
  @ViewChild('inputFriendName', { static: true }) inputFriendNameRef: ElementRef;
  @ViewChild('inputFriendNote', { static: true }) inputFriendNoteRef: ElementRef;

  optionsDatePicker: {};
  isScheduledGifting: boolean;
  isValidScheduledGifting: boolean;
  zipYiElement = ZipYiElement;
  crossDomainCssClass = DEFAULT_CROSS_DOMAIN_CSS_CLASS;

  constructor(
    public selectOptionService: SelectOptionService,
    public validationService: ValidationService,
    public giphyService: GiphyService,
    private trxService: TrxService,
  ) {
    this.optionsDatePicker = {
      minYear: moment().year(),
      minDate: moment(),
      placeholder: 'DD/MM/YYYY',
      displayFormat: 'DD/MM/YYYY',
      barTitleFormat: 'MMMM YYYY',
      barTitleIfEmpty: moment().format('MMMM YYYY'),
    };
    this.isScheduledGifting = false;
    this.isValidScheduledGifting = true;
  }

  showErrorInput(event) {
    event.target.closest('.zip-row-input').classList.remove('is-error');
  }

  hideErrorInput(event) {
    event.target.closest('.zip-row-input').classList.add('is-error');
  }

  checkFieldEmail(event) {
    this.showErrorInput(event);
    if (!this.validationService.validateEmail(this.validationService.friendForm.friendEmail)) {
      this.hideErrorInput(event);
    }
  }

  checkFieldConfirmEmail(event) {
    this.showErrorInput(event);
    if (
      !this.validationService.confirmEmail(
        this.validationService.friendForm.friendEmail,
        this.validationService.friendForm.friendEmailConfirm,
      )
    ) {
      this.hideErrorInput(event);
    }
  }

  checkFieldName(event) {
    this.showErrorInput(event);

    if (
      !this.validationService.checkNull(this.validationService.friendForm.friendName) ||
      !this.validationService.checkLength(this.validationService.friendForm.friendName, 50) ||
      !this.validationService.checkValidName(this.validationService.friendForm.friendName)
    ) {
      this.hideErrorInput(event);
    }
  }

  checkFieldNote(event) {
    this.showErrorInput(event);
    if (
      !this.validationService.checkNull(this.validationService.friendForm.friendNote) ||
      !this.validationService.checkLength(this.validationService.friendForm.friendNote, 100)
    ) {
      this.hideErrorInput(event);
    }
  }

  validateFormFriend() {
    if (
      this.validationService.validateEmail(this.validationService.friendForm.friendEmail) &&
      this.validationService.confirmEmail(
        this.validationService.friendForm.friendEmail,
        this.validationService.friendForm.friendEmailConfirm,
      ) &&
      this.validationService.checkNull(this.validationService.friendForm.friendName) &&
      this.validationService.checkLength(this.validationService.friendForm.friendName, 50) &&
      this.validationService.checkValidName(this.validationService.friendForm.friendName) &&
      this.validationService.checkNull(this.validationService.friendForm.friendNote) &&
      this.validationService.checkLength(this.validationService.friendForm.friendNote, 100)
    ) {
      this.validationService.setIsValid(true);

      return;
    }

    this.validationService.setIsValid(false);
  }

  async confirmBuyForFriend() {
    if (this.validationService.isValid) {
      if (this.validationService.deliveryDate !== '') {
        this.validationService.setDeliveryDateData();
      }

      await this.trxService.sendUIClickEvent({
        action_type: 'click',
        control_type: 'button',
        label: 'Confirm and checkout',
        control_id: null,
        destination_target_url: null,
      });

      this.validationService.setErrorResponse({});
      this.checkoutForFriend.emit();
    }
  }

  dateFilter = (d: Date | null): boolean => {
    return d > moment().toDate();
  };

  getInputField() {
    let arr: any = [];

    arr.push(
      this.inputFriendEmailRef.nativeElement,
      this.inputFriendEmailRef.nativeElement,
      this.inputFriendNameRef.nativeElement,
      this.inputFriendNoteRef.nativeElement,
    );

    this.selectOptionService.checkFieldsInput(arr);
  }

  async doScheduledGifting() {
    this.isScheduledGifting = !this.isScheduledGifting;

    await this.trxService.sendUIClickEvent({
      action_type: this.isScheduledGifting ? 'on' : 'off',
      control_type: 'toggle',
      label: 'Send on a specific date',
      control_id: null,
      destination_target_url: null,
    });

    this.isValidScheduledGifting = true;

    if (this.isScheduledGifting) {
      this.validationService.deliveryDate = moment().add(1, 'days');
    } else {
      this.validationService.setDeliveryDateData('');
    }
  }

  ngOnInit() {
    this.validationService.resetDataFriendForm();
    this.giphyService.setImage('');
  }

  ngDoCheck() {
    if (this.isScheduledGifting && this.validationService.deliveryDate !== '') {
      this.isValidScheduledGifting = true;
    }
  }

  ngAfterViewInit() {
    this.getInputField();
  }
}
